import {Component, EventEmitter, Input, OnInit, Output, OnDestroy} from '@angular/core';
import {TeamState} from '../../../store/team/team.reducer';
import {Store} from '@ngrx/store';
import * as fromTeamActions from '../../../store/team/team.actions';
import * as fromEmployeeActions from '../../../store/employee/employee.actions';
import * as fromEmployeeSelectors from '../../../store/employee/employee.selectors';
import * as fromTeamSelector from './../../../store/team/team.selectors'
import {Update} from '@ngrx/entity';
import {Observable} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {TeamDialogComponent} from '../team-dialog/team-dialog.component';
import {map, take} from 'rxjs/operators';
import {IEmployee, ITeam} from '@signal/asp-data-commons';
import { unsubscribeSubscriptions } from 'src/app/modules/shared/services/util.service';
import { SubscriptionList } from 'src/app/modules/shared/models/asp.types';
import { TeamService } from '../../../shared/services/team-service';


@Component({
  selector: 'app-team-card',
  templateUrl: './team-card.component.html',
  styleUrls: ['./team-card.component.scss']
})
export class TeamCardComponent implements OnInit, OnDestroy {
  @Input() team: ITeam;
 @Output() cdkDragStarted=new EventEmitter();
  employees$: Observable<IEmployee[]>;
  employees:IEmployee[];
  teamFlatRateHours$: Observable<number>;
  empDetailsUpadated: boolean;
  subs:SubscriptionList = {};
  private editDialogConfig = {
    width: '25rem',
    height: '27.625rem',
    panelClass: 'asp-modal-container'
  };
  private deleteConfig = {
    width: '400px',
    height: '220px',
    panelClass: 'asp-modal-container'
  };

  constructor(
    public dialog: MatDialog,
    private employeeState: Store<IEmployee>,
    private teamState: Store<TeamState>,
    private teamService: TeamService) {
  }
  ngOnInit() {
    this.setupStore();
  }
  itemsAdded(ev: IEmployee[], list) {
    /* Add employee to the current team */
    this.teamService.dispatchEmployeeDetails();
    this.employees = ev.map(e=> ({...e, teamId: this.team.id}));
     this.subs.empDetailsUpadated=this.teamState.select(fromTeamSelector.selectUpdateEmployeeDetails).subscribe((empDetailsUpadated)=>{
      if(empDetailsUpadated){
            this.employeeState.dispatch(new fromEmployeeActions.UpdateTeamDetails({employees:this.employees}));
          this.setupStore();
        }
      });
  }
  itemsRemoved(ev: IEmployee[], list) {
    this.employees = ev.map(e=> ({...e, teamId: null}));
    this.subs.empDetailsUpadated=this.teamState.select(fromTeamSelector.selectUpdateEmployeeDetails).subscribe((empDetailsUpadated)=>{
      if(empDetailsUpadated){
          this.employeeState.dispatch(new fromEmployeeActions.UpdateTeamDetails({employees:this.employees}));
          this.setupStore();
        }
      });
  }

  itemsUpdated(ev: IEmployee[], list) {
    /* Update the teams employeeIds array */
    const teamUpdate: Update<ITeam> = {
      id: this.team.id,
      changes: {employeeIds: ev.map(e => e.id)}
    };
    this.teamService.employeeUpdate(teamUpdate);
    setTimeout(() => {
            this.subs.empDetailsUpadated=this.teamState.select(fromTeamSelector.selectUpdateEmployeeDetails).subscribe((empDetailsUpadated)=>{
              this.subs?.empDetailsUpadated?.unsubscribe();
            
              if(empDetailsUpadated && this.employees){
              this.employeeState.dispatch(new fromEmployeeActions.UpdateTeamDetails({employees:this.employees}));
              this.setupStore();
            }

          /* from services we have to clear the teamUpdate array otherwise in case of failure it will cause problem and due to push it will add on employee id. */
          if(!this.employees){
            this.teamService.employeeUpdate([]);
          }
      });
    },1)
  }

  onEdit() {
    const team=this.team;
    const dialogRef = this.dialog.open(TeamDialogComponent, {
      ...this.editDialogConfig,
      data: {team,clicked:true},
      disableClose:true
    });
    this.subs.dialog = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        const teamUpdate: Update<ITeam> = {id: this.team.id, changes: {...event.data}};
        this.teamState.dispatch(new fromTeamActions.UpdateTeam({teamUpdate}));
      }
    });
  }

  onDelete() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, this.deleteConfig);
    this.subs.confirmDialog = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        this.teamState.dispatch(new fromTeamActions.DeleteTeam({id: this.team.id}));

        setTimeout(() => {
          this.employeeState.dispatch(new fromEmployeeActions.LoadEmployees());
        },1000);
      }
    });
  }
  public setupStore() {
    const props = {employeeIds: this.team.employeeIds};
    this.employees$ = this.employeeState
      .select(fromEmployeeSelectors.selectEmployeesByIds, props);
    this.teamFlatRateHours$ = this.employeeState.select(fromEmployeeSelectors.selectFlatRateHoursByIds, props);


  }
  ngOnDestroy(){
    unsubscribeSubscriptions(this.subs);
  }
  public cdkdragStarted(event){
    this.cdkDragStarted.emit(event);
  }
}
